var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yizhijia"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-center center"},[_c('div',{staticClass:"banner-info"},[_c('div',{staticClass:"btn shenqing bgRed",on:{"click":function($event){return _vm.openDialog('免费试用',0)}}},[_vm._v("申请试用")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4c4218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yizhijia.vue
// module id = null
// module chunks = 